import { Printer } from 'lucide-react';
import { calcularTextoConRelleno } from '../rellenoTexto';
import ChequeLienzo from './ChequeLienzo';

export default function ComprobanteEgreso({ preparando, onCancelar, onImprimir }) {
  if (!preparando) return null;
  const { cheque, empresa, calibracion } = preparando;
  const proveedor = cheque.proveedor_datos;
  const montoFormateado = Number(cheque.monto_numero).toLocaleString('en-US', { minimumFractionDigits: 2 });
  const numeroComprobante = cheque.numero_comprobante ? String(cheque.numero_comprobante).padStart(4, '0') : '—';

  const fechaImpresaEnCheque = `${cheque.ciudad ? cheque.ciudad + ' ' : ''}${cheque.fecha_emision}`;
  const { textoFinal: montoTextoImpreso } = calibracion
    ? calcularTextoConRelleno({
        texto: cheque.monto_texto,
        relleno: calibracion.relleno_char,
        fuentePt: Number(calibracion.fuente_pt),
        anchoMm: Number(calibracion.texto_w),
      })
    : { textoFinal: cheque.monto_texto };

  return (
    <>
      <div className="modal-fondo no-imprimir" onClick={onCancelar} />
      <div className="modal-ventana">
      <div className="comprobante-acciones no-imprimir">
        <button type="button" className="btn-primary" onClick={onImprimir}>
          <Printer size={16} /> Imprimir / Guardar como PDF
        </button>
        <button type="button" className="btn-secundario" onClick={onCancelar}>Cerrar</button>
      </div>

      <div className="comprobante-envoltura">
      <div id="comprobante-documento">
        <div className="comprobante-header">
          {empresa.logo && <img src={empresa.logo} alt="Logo" className="comprobante-logo" />}
          <div className="comprobante-empresa-datos">
            <strong>{empresa.nombre}</strong>
            {empresa.ruc && <div>RUC: {empresa.ruc}</div>}
            {empresa.direccion && <div>{empresa.direccion}</div>}
            {empresa.telefono && <div>Tel: {empresa.telefono}</div>}
            {empresa.email && <div>{empresa.email}</div>}
          </div>
        </div>

        <div className="comprobante-cajas">
          <div className="comprobante-caja">
            <div>COMPROBANTE DE EGRESO</div>
            <strong>N° {numeroComprobante}</strong>
          </div>
          <div className="comprobante-caja">
            <div>Cheque N°:</div>
            <strong>{cheque.numero_cheque || '—'}</strong>
          </div>
        </div>

        <div className="comprobante-cuerpo">
          <div className="comprobante-fila comprobante-fila-full">
            <span className="comprobante-label">Proveedor:</span> {cheque.beneficiario}
          </div>
          <div className="comprobante-fila">
            <span className="comprobante-label">CI o RUC:</span> {proveedor?.ruc || ''}
          </div>
          <div className="comprobante-fila">
            <span className="comprobante-label">Teléfono:</span> {proveedor?.telefono || ''}
          </div>
          <div className="comprobante-fila">
            <span className="comprobante-label">Dirección:</span> {proveedor?.direccion || ''}
          </div>
          <div className="comprobante-fila">
            <span className="comprobante-label">Ciudad:</span> {cheque.ciudad || ''}
          </div>
          <div className="comprobante-fila">
            <span className="comprobante-label">Banco:</span> {cheque.banco_nombre}
          </div>
          <div className="comprobante-fila">
            <span className="comprobante-label">Fecha:</span> {cheque.fecha_emision}
          </div>
          <div className="comprobante-fila comprobante-fila-full">
            <span className="comprobante-label">Valor:</span> ${montoFormateado}
          </div>
          <div className="comprobante-fila comprobante-fila-full">
            <span className="comprobante-label">Concepto:</span> {cheque.concepto}
          </div>
          <div className="comprobante-fila comprobante-fila-full">
            <span className="comprobante-label">Valor en letras:</span> {cheque.monto_texto}
          </div>
        </div>

        <div className="comprobante-constancia">
          <div className="comprobante-constancia-lienzo">
            {calibracion?.banco ? (
              <ChequeLienzo
                id="cheque-lienzo-constancia"
                banco={calibracion.banco}
                calibracion={calibracion}
                fecha={fechaImpresaEnCheque}
                nombre={cheque.beneficiario}
                montoFormateado={montoFormateado}
                montoTexto={montoTextoImpreso}
              />
            ) : (
              <p className="ayuda">No se pudo cargar la calibración del banco para mostrar la constancia.</p>
            )}
          </div>
        </div>

        <div className="comprobante-firmas">
          <div className="comprobante-firma">
            <div className="comprobante-linea-firma" />
            <div>Solicitado por</div>
            <div className="comprobante-firma-nombre">{cheque.creado_por_nombre}</div>
          </div>
          <div className="comprobante-firma">
            <div className="comprobante-linea-firma" />
            <div>Aprobado por</div>
            <div className="comprobante-firma-nombre">{cheque.aprobado_por_nombre}</div>
          </div>
          <div className="comprobante-firma">
            <div className="comprobante-linea-firma" />
            <div>Recibí conforme</div>
            <div className="comprobante-firma-nombre">{cheque.beneficiario}</div>
          </div>
        </div>
      </div>
      </div>
      </div>
    </>
  );
}
